// Shared themed icons for closure popups (dev chooses one of 10).
import { Sun, Snowflake, Egg, PawPrint, TreePine, Gift, Umbrella, Heart, Star, Moon } from "lucide-react";

export const CLOSURE_ICONS = {
  sun: Sun,
  snowflake: Snowflake,
  egg: Egg,
  paw: PawPrint,
  tree: TreePine,
  gift: Gift,
  umbrella: Umbrella,
  heart: Heart,
  star: Star,
  moon: Moon,
};

export const CLOSURE_ICON_KEYS = Object.keys(CLOSURE_ICONS);
